export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email); 
};

export const validatePassword = (password) => {
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.#^_-])[A-Za-z\d@$!%*?&.#^_-]{8,}$/;
  // au moins une lettre minuscule, une lettre majuscule, un chiffre, un caractère spécial et une longueur minimale de 8 caractères.
  return regex.test(password); 
};


export const addThousandsSeparator = (num) =>{
      if(num == null || isNaN(num)) return "";
    const [integerPart,fractionalPart] = num.toString().split(".");
    const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return fractionalPart ? `${formattedInteger}.${fractionalPart}` : formattedInteger;
};
